/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'social.mu.newsFeedPrefs'

type $nsid = typeof $nsid

export { $nsid }

/** A user's News feed preferences: the topics and regions they selected and the news sources they opted out of. Stored as a singleton at rkey 'self'. */
type Main = {
  $type: 'social.mu.newsFeedPrefs'

  /**
   * Topic ids the user selected (e.g. 'politics', 'tech'). 'all' disables topic filtering.
   */
  topics: string[]

  /**
   * Region ids the user selected (e.g. 'global', 'uk'). Empty means no region filter.
   */
  regions: string[]

  /**
   * DIDs of curated sources the user opted out of.
   */
  excludedDids: l.DidString[]
  createdAt: l.DatetimeString
}

export type { Main }

/** A user's News feed preferences: the topics and regions they selected and the news sources they opted out of. Stored as a singleton at rkey 'self'. */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    topics: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    regions: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    excludedDids: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
